import { render, staticRenderFns } from "./LeaderboardTable.vue?vue&type=template&id=614e06d5&"
import script from "./LeaderboardTable.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTable.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports